module.exports = __webpack_public_path__ + "static/img/social_8.7915643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/launch/social/social_8.jpg
// module id = geBC
// module chunks = 1